"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsMounted = void 0;
const react_1 = require("react");
const useIsMounted = () => {
    const isMountedRef = (0, react_1.useRef)(true);
    (0, react_1.useEffect)(() => () => {
        isMountedRef.current = false;
    }, []);
    return () => isMountedRef.current;
};
exports.useIsMounted = useIsMounted;
//# sourceMappingURL=index.js.map